import { useFormContext } from 'react-hook-form';

import { FormRow } from '@creditornot/cb-form';
import { Select } from '@creditornot/cb-select';
import { FormField } from 'common/components/cookbook/FormField';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { reasons } from 'features/selection-recommendations/Recommendations/ListingRecommendations/utils';

export const ReasonRow = () => {
  const f = useFormatMessage();
  const { clearErrors } = useFormContext();

  const rejectionReasons = reasons.map((reason) => ({
    label: f(`selection_recommendations_reject_listing_recommendations.reasons:${reason}`),
    value: reason,
  }));

  return (
    <FormRow label={f('selection_recommendations.rejection_reason')} labelHtmlFor="reasons">
      <FormField
        rules={{
          required: f('common.validation.required'),
        }}
        name="reason"
        renderInput={({ ref, ...props }) => (
          <Select
            {...props}
            selectRef={ref}
            placeholder={f('selection_recommendations.reject_select_reason')}
            options={rejectionReasons}
            inputId="reasons"
            onChange={(value) => {
              clearErrors('comment');
              props.onChange?.(value);
            }}
          />
        )}
      />
    </FormRow>
  );
};
